import React, { useState, useEffect, useRef,forwardRef, useImperativeHandle, useContext } from 'react';
import { Button, Modal, Space, message, Layout, Card, Spin, Select, List, Checkbox, Tabs, Input, Table } from 'antd';
import { ReloadOutlined, FolderOpenOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { handleException,downloadFile, useHeighter,OpenDialog,deleteRecord,waitRef,createActionColumn } from './Utils';
import TableOverview from './TableOverview';
import axiosInstance from './axiosInstance';
const { Header, Content, Footer } = Layout;



function ModuleOverview({visible=true}) {
	const [tableHeight] = useHeighter(300);	
	const tableRef = useRef(null);
	const [data, setData] = useState([])

	useEffect(() => { if(visible) handleRefresh() },[visible])
	
	const handleRefresh = async () => { 
		const data = await loadOverview()	
		setData(data)
	}	
	
	async function loadOverview() {
        try {
			const response = await axiosInstance.post('/getoverview', {});
			return response.data
        } catch (error) {
			handleException(error)
        }
    };

	

	return (
		<div style={{ display: visible?'block':'none'}}>
			<h1>Přehled</h1>
			<div className="toolbar">
				<Space>
					<Button icon={<ReloadOutlined/>} onClick={ handleRefresh} >Aktualizovat</Button>
				</Space>
				<Input.Search className="toolbar-search"placeholder="Hledat..." onSearch={(value) => tableRef.current.setSearchInput(value)} />
			</div>

			<TableOverview scroll={{ y: tableHeight }} dataSource={data} ref={tableRef}/>

		</div>
	);	
}

export default ModuleOverview;

